import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Container = styled.div`
  /* margin-top: 6rem; */
  margin-bottom: 30rem;
  display: flex;
  justify-content: center;
  align-items: center;

  & > img {
    width: 95rem;
    height: 80rem;
  }

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: -15rem;
    margin-bottom: 13.4rem;

    & > img {
      width: 35rem;
      height: 30rem;
    }
  }
`;
